import { ReactNode } from 'react'

import TableItem from '@/modules/shared/components/page-header-details-table/TableItem'

interface TableRowSingleProps {
  titleText: string
  tooltipText?: string | React.JSX.Element
  value: string | ReactNode
  update?: string
  testId: string
  customUpdateText?: string
  valueClassName?: string
  titleClassName?: string
}

export function TableRowSingle({
  titleText,
  tooltipText,
  value,
  update,
  testId,
  customUpdateText,
  valueClassName,
  titleClassName,
}: TableRowSingleProps) {
  return (
    <>
      <div className="flex">
        <div className="flex grow items-center">
          <TableItem
            titleText={titleText}
            tooltipText={tooltipText}
            value={value}
            update={update}
            testId={testId}
            customUpdateText={customUpdateText}
            valueClassName={valueClassName}
            titleClassName={titleClassName}
          />
        </div>
      </div>
    </>
  )
}
